export const socialsData = {
  github: "https://github.com/akashp73387",

  linkedIn: "https://www.linkedin.com/in/akash73387/",

  gmail: "akashp73387@gmail.com",
};